module.exports = __webpack_public_path__ + "assets/img/f8ed6cd0be86a175c15d453fec3ca592.png";